import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const CategoryLink = ({ id, name }) => {
    const location = useLocation();
    const isActive =
        location.pathname.startsWith('/search') &&
        location.search.includes(encodeURI(`category=${name}`));

    return (
        <Link
            key={id}
            to={`/search?category=${name}&filter=`}
            className={`nav-link ${isActive ? 'active' : ''}`}>
            {name}
        </Link>
    );
};
